import { proxy, useSnapshot } from 'valtio';

import { BoardThemes } from '@exports/ChessBoard';
import { getLocalStorage } from '@libs/storage';

const LOCAL_STORAGE_KEY = 'boards-theme';
const LOCAL_STORAGE = getLocalStorage();

const BOARD_THEME_STORE = proxy({
  boardTheme: (LOCAL_STORAGE.getItem(LOCAL_STORAGE_KEY) ?? 'classic') as BoardThemes,

  setBoardTheme: (t: BoardThemes) => {
    BOARD_THEME_STORE.boardTheme = t;
    LOCAL_STORAGE.setItem(LOCAL_STORAGE_KEY, t);
  },
});

export function useBoardTheme() {
  return useSnapshot(BOARD_THEME_STORE);
}
